import {
  Show,
  TabbedShowLayout,
  Tab,
  TextField,
  NumberField,
  DateField,
  FunctionField,
} from "react-admin";
import { Box, Typography } from "@mui/material";
import { ProviderStatusChip } from "./ProviderStatusChip";
import { ProviderTypeChip } from "./ProviderTypeChip";
import { ProviderConfigurations } from "./ProviderConfigurations";
import { ProviderBusinessRules } from "./ProviderBusinessRules";
import { ProviderHealth } from "./ProviderHealth";
import { ProviderTestConnection } from "./ProviderTestConnection";

export const ProviderShow = () => (
  <Show>
    <TabbedShowLayout>
      <Tab label="Overview">
        <TextField source="id" label="Provider ID" />
        <TextField source="code" label="Code" />
        <TextField source="name" label="Name" />
        <FunctionField
          label="Type"
          render={() => <ProviderTypeChip />}
        />
        <FunctionField
          label="Status"
          render={() => <ProviderStatusChip />}
        />
        <NumberField source="priority" label="Priority" />
        <TextField source="description" label="Description" multiline />
        <DateField source="createdAt" label="Created At" showTime />
        <DateField source="updatedAt" label="Updated At" showTime />
      </Tab>

      <Tab label="Configurations">
        <ProviderConfigurations />
      </Tab>

      <Tab label="Business Rules">
        <ProviderBusinessRules />
      </Tab>

      <Tab label="Health & Monitoring">
        <Box sx={{ mb: 3 }}>
          <ProviderTestConnection />
        </Box>
        <ProviderHealth />
      </Tab>

      <Tab label="System Information">
        <TextField source="id" label="Provider ID" />
        <DateField source="createdAt" label="Created At" showTime />
        <DateField source="updatedAt" label="Updated At" showTime />
        <FunctionField
          label="Metadata"
          render={(record) => (
            <Box
              component="pre"
              sx={{
                p: 2,
                bgcolor: "grey.100",
                borderRadius: 1,
                overflow: "auto",
                fontSize: "0.875rem",
              }}
            >
              {JSON.stringify(
                {
                  code: record.code,
                  name: record.name,
                  type: record.type,
                  status: record.status,
                },
                null,
                2,
              )}
            </Box>
          )}
        />
      </Tab>
    </TabbedShowLayout>
  </Show>
);
